// Construcción del enlace al anuncio ORIGINAL de un lote.
// Zuchlag es agregador: siempre hay que poder ir a la fuente original.
//
// Prioridad:
//   1. lot.original_url (si la fuente lo entrega)
//   2. Regla por fuente conocida (Troostwijk: /en/l/{external_id})
//   3. URL de la subasta si está disponible como último recurso
export function originalUrl(lot) {
  if (!lot) return null

  if (lot.original_url) return lot.original_url

  const sourceCode = (lot.source && (lot.source.code || lot.source.name)) || ''
  const ext = lot.external_id

  // Troostwijk: https://www.troostwijkauctions.com/en/l/{external_id}  (verificado HTTP 200)
  if (/troostwijk/i.test(sourceCode) && ext) {
    return `https://www.troostwijkauctions.com/en/l/${encodeURIComponent(ext)}`
  }

  // Otros auktionshäuser pueden añadirse aquí con su patrón.
  return null
}
